function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.38281 2.75781C3.97135 1.16927 5.88542 0.375 8.125 0.375C10.3646 0.375 12.2786 1.16927 13.8672 2.75781C15.4557 4.34635 16.25 6.26042 16.25 8.5C16.25 10.7396 15.4557 12.6536 13.8672 14.2422C12.2786 15.8307 10.3646 16.625 8.125 16.625C5.88542 16.625 3.97135 15.8307 2.38281 14.2422C0.794271 12.6536 0 10.7396 0 8.5C0 6.26042 0.794271 4.34635 2.38281 2.75781ZM2.85156 13.7734C4.3099 15.2318 6.06771 15.9609 8.125 15.9609C10.1823 15.9609 11.9401 15.2318 13.3984 13.7734C14.8568 12.3151 15.5859 10.5573 15.5859 8.5C15.5859 6.44271 14.8568 4.6849 13.3984 3.22656C11.9401 1.76823 10.1823 1.03906 8.125 1.03906C6.06771 1.03906 4.3099 1.76823 2.85156 3.22656C1.39323 4.6849 0.664062 6.44271 0.664062 8.5C0.664062 10.5573 1.39323 12.3151 2.85156 13.7734ZM3.125 8.85156V8.1875H13.125V8.85156H3.125Z",
  fill: "#C2C2C2"
});

var SvgMinus = function SvgMinus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMinus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minus.1414e5c7.svg";
export { ForwardRef as ReactComponent };